<template>
  <div class="reset-pwd">
    <h4>{{ productName }}</h4>
    <div class="bd">
      <van-field
        v-model="form.userName"
        input-align="right"
        is-link
        label="姓名"
        label-class="new-cell"
        name="userName"
        placeholder="请填写姓名"
        required
        size="large"
      />
      <van-field
        v-model="form.phone"
        input-align="right"
        is-link
        label="手机号"
        label-class="new-cell"
        name="phone"
        placeholder="请填写手机号"
        size="large"
      />
      <div style="margin: 20px 16px 16px">
        <van-button
          block
          :loading="submitLoading"
          native-type="submit"
          round
          type="primary"
          @click="onSubmit"
        >
          领取
        </van-button>
      </div>
    </div>
  </div>
</template>
<script>
  import store from '@/store'
  import { Toast } from 'vant'
  import { wxShare } from '@/utils/index'
  export default {
    data() {
      return {
        productName: '',
        submitLoading: false,
        form: {
          userName: '',
          phone: '',
          packageId: '',
          packageDetailId: '',
        },
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        const query = this.$route.query
        this.productName = query.productName
        const userInfo = store.getters['user/getUserInfo']
        this.form.userName = userInfo.UserName
        this.form.phone = userInfo.Phone
        this.form.packageId = query.packageId
        this.form.packageDetailId = query.packageDetailId
        setTimeout(() => {
          wxShare('领取' + this.productName)
        }, 1000)
      },
      onSubmit() {
        if (!this.form.userName.trim()) {
          Toast('请输入姓名！')
          return
        }
        this.submitLoading = true
        store
          .dispatch('service/PackageReceive', this.form)
          .then((data) => {
            this.submitLoading = false
            Toast.success('领取成功！')
            setTimeout(() => {
              this.$router.push({ name: 'Index' })
            }, 2000)
          })
          .catch((e) => {
            this.submitLoading = false
            Toast(e.Message || '操作失败')
            setTimeout(() => {
              this.$router.push({ name: 'Index' })
            }, 2000)
          })
      },
    },
  }
</script>
<style lang="scss" scoped>
  h4 {
    text-align: center;
    padding: 16px 0;
  }
</style>
